import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

const RouteWithTitle = ({ component, path, name, exact }) => {
    document.title = getDocumentTitle(name);
    // withRouter() must NOT be called inline in the render — doing so creates a
    // new component type on every render, causing React to unmount and remount
    // the page component (losing all state and re-firing useEffect).
    const WrappedComponent = useMemo(() => withRouter(component), [component]);
    return (
        <Route component={WrappedComponent} path={path} exact={exact} />
    );
};
function getDocumentTitle(name) {
    let titleParts = document.title.split('|');
    titleParts[0] = 'StaffPay';
    titleParts[1] = ` ${name} `;
    return titleParts.join(' |');
}

export default RouteWithTitle;
